import Navbar from "@/components/funnel/Navbar";
import GlobalAudioPlayer from "@/components/GlobalAudioPlayer";
import FixedActionButtons from "@/components/FixedActionButtons";
import HeroSection from "@/components/funnel/HeroSection";
import ProblemSection from "@/components/funnel/ProblemSection";
import VideoQuoteSection from "@/components/funnel/VideoQuoteSection";
import MethodTeaseSection from "@/components/funnel/MethodTeaseSection";
import TestimonialsSection from "@/components/funnel/TestimonialsSection";

import SketchShowcaseSection from "@/components/funnel/SketchShowcaseSection";
import FAQSection from "@/components/funnel/FAQSection";
import FinalCTASection from "@/components/funnel/FinalCTASection";
import LandingRegistrationSection from "@/components/funnel/LandingRegistrationSection";
import FooterSection from "@/components/funnel/FooterSection";
import { useInteractionTracking } from "@/hooks/useInteractionTracking";

const Landing = () => {
  useInteractionTracking("page_view", { page: "landing" });
  return (
    <main className="min-h-screen bg-background overflow-x-hidden">
      <GlobalAudioPlayer />
      <FixedActionButtons />
      <Navbar />
      <HeroSection />
      <ProblemSection />
      <SketchShowcaseSection />
      <VideoQuoteSection />
      <MethodTeaseSection />
      <TestimonialsSection />
      <LandingRegistrationSection />
      <FAQSection />
      <FooterSection />
    </main>
  );
};

export default Landing;
